import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService, FichaReceita } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class AnexoLRFService extends BaseResourceService<FichaReceita> {

  constructor(
    protected injector: Injector
  ) {
    super(`contabil-relatorio`, injector);
  }

  obterBalancoOrcamentario(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/balanco-orcamentario/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterAnexo1RPPS(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/anexo1-rpps/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterRCL(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/rcl/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterDCL(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/dcl/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterDCLRpps(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/dcl-rpps/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterFuncaoSubfuncao(mes: number, exercicio: number, orgaos: number[], funcao?: number, recurso?: number): Observable<any> {
    let parametros = '';
    if (recurso)
      parametros = `?recurso=${recurso}`;
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/funcao-subfuncao/${mes}/${exercicio}/${orgaos.join()}`
      + (funcao ? `/${funcao}` : '') + parametros,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterDespesaPessoal(mes: number, exercicio: number, orgaos: number[], executivo: boolean, percentual: boolean): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/despesas-pessoal/${mes}/${exercicio}/${orgaos.join()}/${executivo}/${percentual}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterResultadoPrimario(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/resultado-primario/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }


  disponibilidadeFinanceiraRpps(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/disponibilidade-financeira-rpps/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterResultadoNominal(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/resultado-nominal/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterResultadoNominalRpps(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/resultado-nominal-rpps/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterRGF(mes: number, exercicio: number, orgaos: number[], executivo: boolean): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/rgf/${mes}/${exercicio}/${orgaos.join()}/${executivo}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterOperacaoCredito(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/operacao-credito/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterRestosPagar(mes: number, exercicio: number, cidade: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/restos-pagar/${mes}/${exercicio}/${cidade}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterDisponibilidaFinanceira(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/disponibilidade-financeira/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  obterReceitaAlienacao(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/receita-alienacao/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterDemonstrativoReceitaDespesaPrevidencia(mes: number, exercicio: number, orgaos: number[]): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/demonstrativo-receita-despesa-previdencia/${mes}/${exercicio}/${orgaos.join()}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterDemonstrativoApuracaoCumprimento(exercicio: number, bimestre: number): Observable<any> {
    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/apuracao-cumprimento/${exercicio}/${bimestre}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterSqlViaBanco(params: any): Observable<any> {
    const queryParameter = new URLSearchParams(params).toString()
    return this.http.get(`${this.login.cidade.id}/${this.api}/sql-via-banco?${queryParameter}`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  buscarLayoutAnexos(): Array<{ codigo: string, nome: string, layout: string, atualizacao: string, download: string }> {
    const layout = [];

    layout.push({ codigo: 'A1', nome: 'RREO ANEXO 1 - BALANÇO ORÇAMENTÁRIO', layout: 'RREO - ANEXO 01 - BO MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2001%20-%20BO%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A2', nome: 'RREO ANEXO 2 - EXECUÇÃO DAS DESPESAS POR FUNÇÃO/SUBFUNÇÃO', layout: 'RREO - ANEXO 02 - FUNÇÃO SUBFUNÇÃO MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2002%20-%20FUN%c3%87%c3%83O%20SUBFUN%c3%87%c3%83O%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A3', nome: 'RREO ANEXO 3 - RECEITA CORRENTE LÍQUIDA', layout: 'RREO - ANEXO 03 - RCL MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2003%20-%20RCL%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A4', nome: 'RREO ANEXO 4 - RECEITAS E DESPESAS PREVIDENCIÁRIAS', layout: 'RREO - ANEXO 04 - Receitas e Despesas Previdenciárias - MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '04/2026', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2004%20-%20Receitas%20e%20Despesas%20Previdenci%c3%a1rias%20-%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A6', nome: 'RREO ANEXO 6 - RESULTADOS PRIMÁRIO E NOMINAL', layout: 'RREO - ANEXO 06 - Resultados Primário e Nominal MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '04/2026', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2006%20-%20Resultados%20Prim%c3%a1rio%20e%20Nominal%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A7', nome: 'RREO ANEXO 7 - RESTOS A PAGAR POR PODER E ÓRGÃO', layout: 'RREO - ANEXO 07 - Restos a Pagar por Poder e Órgao MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2007%20-%20Restos%20a%20Pagar%20por%20Poder%20e%20%c3%93rgao%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A8', nome: 'RREO ANEXO 8 - RECEITAS E DESPESAS COM MANUTENÇÃO E DESENVOLVIMENTO DO ENSINO - MDE', layout: 'RREO - Anexo 08 - MDE - MDF 15ª ed - MSC 2026.xlsx', atualizacao: '04/2026', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2008%20-%20MDE%20-%20MDF%2015%c2%aa%20ed%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A9', nome: 'RREO ANEXO 9 - RECEITAS DE OPERAÇÕES DE CRÉDITO E DESPESAS DE CAPITAL (REGRA DE OURO)', layout: 'RREO - ANEXO 09 - Op. de Crédito e Desp. de Capital MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2009%20-%20Op.%20de%20Cr%c3%a9dito%20e%20Desp.%20de%20Capital%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A11', nome: 'RREO ANEXO 11 - RECEITA DE ALIENAÇÃO DE ATIVOS E APLICAÇÃO DOS RECURSOS', layout: 'RREO - ANEXO 11 - Alienação de Ativos MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2011%20-%20Aliena%c3%a7%c3%a3o%20de%20Ativos%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A12', nome: 'RREO ANEXO 12', layout: 'RREO - ANEXO 12 - ASPS - MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2012%20-%20ASPS%20-%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'A13', nome: 'RREO ANEXO 13', layout: 'RREO - ANEXO 13 - PPP MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RREO%20-%20ANEXO%2013%20-%20PPP%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'R1', nome: 'RGF ANEXO 1 - DESPESA COM PESSOAL', layout: 'RGF - ANEXO 1 - Despesas com Pessoal MDF 15ª ed. -  MSC 2026.xlsx', atualizacao: '04/2026', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RGF%20-%20ANEXO%201%20-%20Despesas%20com%20Pessoal%20MDF%2015%c2%aa%20ed.%20-%20%20MSC%202026.xlsx' });
    layout.push({ codigo: 'R2', nome: 'RGF ANEXO 2 - DÍVIDA CONSOLIDADA LÍQUIDA', layout: 'RGF - ANEXO 2 - Dívida Consolidada Líquida MDF 15ª ed.- MSC 2026.xlsx', atualizacao: '04/2026', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RGF%20-%20ANEXO%202%20-%20D%c3%advida%20Consolidada%20L%c3%adquida%20MDF%2015%c2%aa%20ed.-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'R3', nome: 'RGF ANEXO 3 - GARANTIAS E CONTRAGARANTIAS DE VALORES', layout: 'RGF - ANEXO 3 - Garantias e Contragarantias MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RGF%20-%20ANEXO%203%20-%20Garantias%20e%20Contragarantias%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'R4', nome: 'RGF ANEXO 4 - OPERAÇÕES DE CRÉDITO', layout: 'RGF - ANEXO 4 - Operações de Crédito - MDF 15ª edição - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RGF%20-%20ANEXO%204%20-%20Opera%c3%a7%c3%b5es%20de%20Cr%c3%a9dito%20-%20MDF%2015%c2%aa%20edi%c3%a7%c3%a3o%20-%20MSC%202026.xlsx' });
    layout.push({ codigo: 'R5', nome: 'RGF ANEXO 5 - DISPONIBILIDADE DE CAIXA E DOS RESTOS A PAGAR', layout: 'RGF - ANEXO 5 - Disponibilidade de Caixa e dos Restos a Pagar - MDF 15ª ed. - MSC 2026.xlsx', atualizacao: '12/2025', download: 'https://www2.eddydata.com.br/ArquivosExtrasSistemas/layouts/RGF%20-%20ANEXO%205%20-%20Disponibilidade%20de%20Caixa%20e%20dos%20Restos%20a%20Pagar%20-%20MDF%2015%c2%aa%20ed.%20-%20MSC%202026.xlsx' });

    return layout;
  }
}
